import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ScrollToTop } from "@/components/shared/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AdvisoryCirclePage from "@/pages/AdvisoryCirclePage";
import ExecutiveDinnersPage from "@/pages/ExecutiveDinnersPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyDetailPage from "@/pages/CaseStudyDetailPage";
import ApplyPage from "@/pages/ApplyPage";
import LoginPage from "@/pages/LoginPage";
import ForOrganizationsPage from "@/pages/ForOrganizationsPage";
import ForOrgsVCPage from "@/pages/ForOrgsVCPage";
import ForOrgsAcceleratorsPage from "@/pages/ForOrgsAcceleratorsPage";
import ForOrgsCommunitiesPage from "@/pages/ForOrgsCommunitiesPage";
import ForOrgsCohortsPage from "@/pages/ForOrgsCohortsPage";
import OperatorPacketPage from "@/pages/OperatorPacketPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col pb-16 lg:pb-0">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/advisory-circle" element={<AdvisoryCirclePage />} />
            <Route path="/the-table" element={<ExecutiveDinnersPage />} />
            <Route path="/executive-dinners" element={<Navigate to="/the-table" replace />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/for-organizations" element={<ForOrganizationsPage />} />
            <Route path="/for-organizations/venture-capital" element={<ForOrgsVCPage />} />
            <Route path="/for-organizations/accelerators" element={<ForOrgsAcceleratorsPage />} />
            <Route path="/for-organizations/communities" element={<ForOrgsCommunitiesPage />} />
            <Route path="/for-organizations/cohorts" element={<ForOrgsCohortsPage />} />
            <Route path="/resources/operator-packet" element={<OperatorPacketPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
